import React from 'react';

interface OrdersIconProps {
  className?: string;
  size?: number;
}

/**
 * Ícono de "Órdenes"
 * 
 * DESCRIPCIÓN VISUAL:
 * - Un paquete/caja envuelta con cinta adhesiva
 * - Forma de caja rectangular con esquinas redondeadas
 * - Cinta adhesiva cruzada (como una X) sobre la caja
 * - Líneas que sugieren el doblez y envoltura del papel/cartón
 * - Estilo minimalista, representa envíos o pedidos empaquetados
 * - Similar a un paquete de Amazon o correo tradicional
 * 
 * Usa currentColor para adaptarse automáticamente al tema light/dark
 */
export const OrdersIcon: React.FC<OrdersIconProps> = ({
  className = '',
  size = 150,
}) => {
  return (
    <svg
      width={size}
      height={(size * 162) / 150}
      viewBox="0 0 150 162"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M66.5312 154.388C68.4062 155.416 70.4375 156.071 72.5 156.382V83.5978L5.9375 48.0468C5.34375 49.8228 5 51.7234 5 53.6552V110.238C5 116.594 8.46875 122.452 14.0625 125.536L66.5625 154.419L66.5312 154.388ZM83.4375 154.388L135.938 125.505C141.531 122.42 145 116.594 145 110.207V53.624C145 51.6922 144.688 49.7916 144.062 48.0156L127.5 56.8644V93.1632C127.5 94.0668 127 94.908 126.219 95.3443L101.219 109.365C100.438 109.801 99.5 109.801 98.7188 109.334C97.9375 108.867 97.4688 108.057 97.4688 107.184V72.9107L77.4688 83.5978V156.382C79.5312 156.102 81.5625 155.416 83.4375 154.388ZM122.5 53.9356V53.6863L53.8125 15.1442L34.3125 26.5479L101.219 64.093L102.344 64.7162L122.5 53.9667V53.9356ZM127.5 51.256L141.812 43.6224C140.406 41.6283 138.531 39.8834 136.344 38.606L83.8438 7.91555C78.375 4.7063 71.5938 4.7063 66.125 7.91555L58.7812 12.2153L126.219 50.0409L127.5 50.7575V51.256ZM102.5 70.2622V102.947L122.5 91.7299V59.5751L102.5 70.2622ZM97.125 67.458L29.3125 29.4144L13.6562 38.5748C11.4687 39.8523 9.625 41.5659 8.1875 43.5912L75 79.298L97.125 67.458ZM85.8438 158.719C79.0938 162.427 70.875 162.427 64.125 158.719L11.625 129.836C4.4375 125.879 0 118.37 0 110.207V53.624C0 45.6788 4.21875 38.2944 11.125 34.275L63.625 3.58462C70.6562 -0.528207 79.3438 -0.528207 86.375 3.58462L138.875 34.275C145.75 38.2944 150 45.6476 150 53.624V110.207C150 118.37 145.531 125.91 138.375 129.836L85.875 158.719H85.8438Z"
        fill="currentColor"
      />
    </svg>
  );
};

